/* eslint-disable import/no-default-export */
export default {
  searchTitle: 'Candidate Lookup',
  name: 'Name',
  email: 'Email Address',
  selectStatus: 'Select Status',
  enterHireId: 'Hire ID',
  requisitionId: 'Requisition',
  enterRequisition: 'Enter Requisition',
  enterLocationId: 'Enter location id or name',
  statusSelected: `{{statusCount}} status(es) selected`,
  filter: {
    status: {
      label: 'Status',
      all: 'All Status',
      search: 'Search Status...',
    },
  },
  tableHeader: {
    candidateName: 'Candidate Name',
    location: 'Location & Position Name',
    phone: 'Phone',
    status: 'Status',
    lastUpdate: 'Last Update',
    hireId: 'Hire ID',
  },
  showingPageResults: 'Showing {{currentItems}} of {{totalItems}} candidates',
  showingOnePageResult: 'Showing {{currentItems}} of {{totalItems}} candidate',
  exploreProfiles: 'Explore Candidate Profiles',
  enterDetailsText: `It looks like you haven't searched for anything yet. Enter your criteria above to find candidates that fit what you're looking for!`,
  noMatchFound: 'No Candidates Found',
  noMatchFoundText: `There are no candidates that match your search criteria. Try adjusting your filters or keywords to get a better result.`,
  candidateStatus: {
    DISMISSED: 'Dismissed',
    NOT_LOOKING_FOR_WORK: 'Not Looking for Work',
    HIRED: 'Hired',
    HIRE_IN_REVIEW: 'Hire in Review',
    HIRED_ON_ANOTHER_POSITION: 'Hired on Another Position',
    UNHIRED: 'Unhired',
    OFFER_MADE: 'Offer Made',
    OFFER_REJECTED: 'Offer Rejected',
    OFFER_REVOKED: 'Offer Revoked',
    CONTACT_REQUESTED: 'Contact Requested',
    CONTACT_REQUEST_ACCEPTED: 'Contact Request Accepted',
    CONTACT_REQUEST_DECLINED: 'Contact Request Declined',
    APPOINTMENT_REQUESTED: 'Interview Requested',
    APPOINTMENT_ACCEPTED: 'Interview Accepted',
    APPOINTMENT_DECLINED: 'Interview Declined',
    APPOINTMENT_CANCELLED: 'Interview Canceled',
    APPOINTMENT_RESCHEDULING_NEEDED: 'Interview Rescheduling Needed',
    BOOKMARKED: 'Bookmarked',
    LIKED: 'Applied',
    BLACKLISTED: 'Blacklisted',
    UNKNOWN: 'Unknown',
    INTEREST_REVOKED: 'Revoked Application',
    APPOINTMENT_REQUEST_MODIFIED: 'Appointment Request Modified',
    HIRE_FORM_REQUESTED: 'Hire Form Requested',
    HIRE_FORM_IN_PROGRESS: 'Hire Form In Progress',
    HIRE_FORM_HELP_REQUESTED: 'Hire Form Help Requested',
  },
  copiedHireId: 'Copied Hire Form ID.',
  filters: {
    title: 'Candidate Lookup',
    info: 'Minimum of 4 characters are required to search candidate details',
    selectAll: 'Select all',
    reset: 'Reset',
    name: {
      label: 'Name',
      placeholder: 'Enter candidate name',
    },
    phone: {
      label: 'Phone',
      placeholder: 'Enter phone number',
    },
    email: {
      label: 'Email',
      placeholder: 'Enter email address',
    },
    hireId: {
      label: 'Hire Id',
      placeholder: 'Enter hire ID',
    },
    requistion: {
      label: 'Requisition',
      placeholder: 'Enter requisition ID',
    },
    status: {
      label: 'Status',
      placeholder: 'Select status(es)',
      searchPlaceholder: 'Search for statuses',
      allSelected: 'All statuses',
    },
    location: {
      label: 'Locations',
      placeholder: 'Select locations',
      searchPlaceholder: 'Search locations',
      allSelected: 'All locations',
    },
    position: {
      label: 'Positions',
      placeholder: 'Select positions',
      searchPlaceholder: 'Search positions',
      allSelected: 'All positions',
    },
  },
};
